import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "train"
const TrainIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 4c-3.5 0-7 .447-7 3.579v8.5c0 1.73 1.371 3.131 3.063 3.131L6.75 20.553V21h1.951l1.75-1.79h3.299L15.5 21h1.75v-.447l-1.313-1.343C17.63 19.21 19 17.808 19 16.08v-8.5C19 4.447 15.867 4 12 4ZM8.062 17.421c-.724 0-1.312-.6-1.312-1.342 0-.741.588-1.342 1.313-1.342.724 0 1.312.6 1.312 1.342 0 .741-.588 1.342-1.313 1.342Zm3.063-6.263H6.75V7.579h4.375v3.579Zm1.75 0V7.579h4.375v3.579h-4.375Zm3.063 6.263c-.725 0-1.313-.6-1.313-1.342 0-.741.588-1.342 1.313-1.342.724 0 1.312.6 1.312 1.342 0 .741-.588 1.342-1.313 1.342Z"
          />
        </svg>
      }
    </span>
  )
}
export default TrainIcon
